import { IAjaxCreationMethod, IAjaxRequest } from '@microsoft/portal-app/lib/auth';
import { IAction } from '@microsoft/portal-app/lib/redux';
import { addAjaxEpic, getSuccessActionType } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { NavBarData } from '@suiteux/suiteux-shell-applauncher';
import { v4 as uuidv4 } from 'uuid';
import { settingsManager } from '../../../shared/settings';
import { AccountActions, IAccountState } from '../../models';
import { accountRegistry as registry } from '../accountRegistry';

export const getNavBarDataAjax = (ajax: IAjaxCreationMethod, action: IAction<string>) => {
  const token = action.payload;
  return ajax.getJSON(callShellApi(token));
};

export const getNarBarDataAjaxResponse = (state: IAccountState, action: IAction): IAccountState => {
  if (action.payload === undefined) {
    return state;
  }
  const response = action.payload;
  return {
    ...state,
    navBarData: response as NavBarData,
  };
};

export const callShellApi = (token?: string): IAjaxRequest => {
  const audience = settingsManager.get('officeSuiteHeaderAudience') ?? '';
  return {
    url: `${audience}/api/shell/navbardata?CurrentMainLinkId=AADMyApps&TrackingGuid=${uuidv4()}`,
    headers: {
      Authorization: 'Bearer ' + token,
    },
  };
};

addAjaxEpic(registry, AccountActions.getNavBarData, getNavBarDataAjax, {
  showErrorAsToast: false,
});

registry.add(getSuccessActionType(AccountActions.getNavBarData), getNarBarDataAjaxResponse);
